module.exports = __webpack_public_path__ + "static/img/1c.6cd96d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/1c.png
// module id = OjGd
// module chunks = 0